'use client';

import { useRouter } from 'next/navigation';
import CaretIcon from 'components/icons/CaretIcon';
import UIButton from 'components/buttons/UIButton';

interface BackButtonProps {
  className?: string;
}

export default function BackButton({ className }: BackButtonProps) {
  const router = useRouter();

  return (
    <UIButton
      buttonType="tonal"
      label="Back"
      icon={<CaretIcon color="purple" direction="left" size="large" />}
      className={className ? ` ${className}` : ''}
      onClick={() => router.back()}
      iconPosition="left"
    />
  );
}
